"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgIndexPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL LIBRARY BITS
const organizations_service_1 = require("./organizations.service");
let OrgIndexPipe = class OrgIndexPipe {
    constructor(_organizations) {
        this._organizations = _organizations;
    }
    transform(value) {
        return this._organizations.getOrgById(value);
    }
};
exports.OrgIndexPipe = OrgIndexPipe;
exports.OrgIndexPipe = OrgIndexPipe = __decorate([
    (0, core_1.Pipe)({ name: 'orgIndex' }),
    __metadata("design:paramtypes", [organizations_service_1.OrganizationsService])
], OrgIndexPipe);
//# sourceMappingURL=org-index.pipe.js.map